import { RequestStatus } from '@atlassian/mpac-api-client';
const FILTER_OPTIONS = [{
  label: 'All requests',
  value: 'ALL'
}, {
  label: 'Open requests',
  value: RequestStatus.OPEN
}, {
  label: 'Installed requests',
  value: RequestStatus.INSTALLED
}, {
  label: 'Rejected requests',
  value: RequestStatus.REJECTED
}];
export default FILTER_OPTIONS;